import React, { useMemo } from 'react';
import { countStockFromProducts } from './adminCheckoutUtils';
import { catalogShopGroupHealth } from './catalogHealthUtils';
import {
  AdminPanelAlert,
  AdminPanelHero,
  AdminPanelSection,
  AdminPanelStat,
  AdminPanelStatGrid,
} from './AdminPanelUi';

export default function AdminOverviewPanel({
  sortedCategories,
  editableProducts,
  catalogDbActive,
  onGoAnalytics,
  onGoProducts,
}) {
  const stats = useMemo(() => {
    let n = 0;
    sortedCategories.forEach((c) => {
      n += editableProducts[c.slug]?.length || 0;
    });
    return { categories: sortedCategories.length, products: n };
  }, [sortedCategories, editableProducts]);

  const stock = useMemo(
    () => countStockFromProducts(sortedCategories, editableProducts),
    [sortedCategories, editableProducts]
  );

  const shopGroupHealth = useMemo(
    () => catalogShopGroupHealth(editableProducts, sortedCategories),
    [editableProducts, sortedCategories]
  );

  return (
    <div className="admin-overview admin-panel-workspace-root">
      <AdminPanelHero
        title="Overview"
        lead="Quick snapshot of your catalog and a shortcut to shop analytics."
      />

      <AdminPanelSection
        title="Catalog"
        subtitle="Use Categories and Products to manage the shop. Changes publish automatically."
        action={
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onGoProducts}>
            Manage products
          </button>
        }
      >
        <AdminPanelStatGrid>
          <AdminPanelStat label="Categories" value={stats.categories} accent="wine" />
          <AdminPanelStat label="Products" value={stats.products} accent="wine" />
          <AdminPanelStat
            label="Out of stock"
            value={stock.out}
            hint={`${stock.low} low (≤3)`}
            danger={stock.out > 0}
          />
          <AdminPanelStat
            label="Catalog"
            value={catalogDbActive ? 'Live' : 'Offline'}
            hint={catalogDbActive ? 'Connected to database' : 'Using backup data'}
            accent={catalogDbActive ? 'success' : undefined}
          />
        </AdminPanelStatGrid>
        {shopGroupHealth.total > 0 && !shopGroupHealth.ok ? (
          <AdminPanelAlert variant="warning" className="mt-3 mb-0">
            <strong>{shopGroupHealth.needsWork}</strong> product{shopGroupHealth.needsWork === 1 ? '' : 's'} need a shop
            group assigned
            {shopGroupHealth.emptyGroupCount > 0
              ? ` · ${shopGroupHealth.emptyGroupCount} empty group tile${shopGroupHealth.emptyGroupCount === 1 ? '' : 's'}`
              : ''}
            . Open <button type="button" className="btn btn-link btn-sm p-0 align-baseline" onClick={onGoProducts}>Products</button> to fix.
          </AdminPanelAlert>
        ) : null}
      </AdminPanelSection>

      <AdminPanelSection
        title="Shop analytics"
        subtitle="Revenue, orders, customers, categories, payment mix, and gift finder insights."
        action={
          <button type="button" className="btn btn-primary btn-sm" onClick={onGoAnalytics}>
            Open analytics
          </button>
        }
      >
        <p className="small text-muted mb-0">
          Compare periods, export CSV, and spot trends without leaving the admin.
        </p>
      </AdminPanelSection>
    </div>
  );
}
